import React from 'react';
import { Sword, Zap } from 'lucide-react';
interface MainMenuProps {
  onStart: () => void;
  onBossFight: () => void;
}
export function MainMenu({
  onStart,
  onBossFight
}: MainMenuProps) {
  return <div className="absolute inset-0 flex items-center justify-center overflow-hidden" data-id="element-41">
      {/* Pixel art forest background */}
      <div className="absolute inset-0 w-full h-full animate-scroll" style={{
      backgroundImage: 'url(https://uploadthingy.s3.us-west-1.amazonaws.com/3JFWWujrvX6pN8jBniibAi/91cc401f51287f6cde01233e7f01623f.png)',
      backgroundRepeat: 'repeat-x',
      backgroundPosition: 'center bottom',
      backgroundSize: 'auto 100%',
      imageRendering: 'pixelated'
    }} data-id="element-42" />

      {/* Dark overlay for better text readability */}
      <div className="absolute inset-0 bg-black/20" data-id="element-43" />

      <div className="relative z-10 text-center space-y-8 px-8" data-id="element-44">
        <div className="space-y-2" data-id="element-45">
          <h1 className="text-7xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 via-red-500 to-purple-600 animate-pulse" style={{
          textShadow: '0 0 30px rgba(255, 215, 0, 0.5)',
          filter: 'drop-shadow(0 4px 8px rgba(0, 0, 0, 0.8))'
        }} data-id="element-46">
            PIXEL WARRIOR
          </h1>
          <p className="text-xl text-purple-300 drop-shadow-lg" data-id="element-47">
            Ultimate Platformer Battle
          </p>
        </div>

        <div className="space-y-4 max-w-md mx-auto" data-id="element-48">
          <button onClick={onStart} className="w-full px-8 py-4 bg-gradient-to-r from-blue-600 to-blue-500 hover:from-blue-500 hover:to-blue-400 text-white font-bold text-xl rounded-lg shadow-lg transform hover:scale-105 transition-all duration-200 flex items-center justify-center gap-3" style={{
          boxShadow: '0 0 20px rgba(59, 130, 246, 0.5)',
          filter: 'drop-shadow(0 4px 8px rgba(0, 0, 0, 0.5))'
        }} data-id="element-49">
            <Zap className="w-6 h-6" data-id="element-50" />
            START GAME
          </button>

          <button onClick={onBossFight} className="w-full px-8 py-4 bg-gradient-to-r from-red-600 to-red-500 hover:from-red-500 hover:to-red-400 text-white font-bold text-xl rounded-lg shadow-lg transform hover:scale-105 transition-all duration-200 flex items-center justify-center gap-3" style={{
          boxShadow: '0 0 20px rgba(239, 68, 68, 0.5)',
          filter: 'drop-shadow(0 4px 8px rgba(0, 0, 0, 0.5))'
        }} data-id="element-51">
            <Sword className="w-6 h-6" data-id="element-52" />
            BOSS BATTLE
          </button>
        </div>

        <div className="text-purple-300 text-sm space-y-1 drop-shadow-lg" data-id="element-53">
          <p data-id="element-54">• Buttery-smooth 60fps gameplay</p>
          <p data-id="element-55">• Dynamic lighting & particle effects</p>
          <p data-id="element-56">• Reactive music system</p>
          <p data-id="element-57">• Fluid combo mechanics</p>
        </div>
      </div>
    </div>;
}